import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SingleValue } from 'react-select';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useMarkedOptionLabel } from 'src/hooks/useMarkedOptionLabel';
import type { Option } from 'src/types';
import { useOwnersOptions } from '../hooks/useOwnersOptions';

interface OwnerFilterProps {
  value: Option<string> | null;
  onChange: (value: SingleValue<Option<string>>) => void;
  label?: string;
}

export const OwnerFilter: React.FC<OwnerFilterProps> = React.memo(function OwnerFilter({ value, onChange, label }) {
  const [t] = useTranslation(['backend', 'common']);
  const formatOptionLabel = useMarkedOptionLabel({ t });
  const { options, pending: loading, total, searchFilter, setSearchFilter } = useOwnersOptions();

  const handleChange = useCallbackRef((option: SingleValue<Option<string>>) => {
    const ownerOption = option ? { label: option.label, value: option.value ?? '' } : null;
    onChange(ownerOption);
  });

  return (
    <Filter<string>
      label={label || t('common:SALES')}
      loading={loading}
      selected={value}
      onChange={handleChange}
      serverSideFiltering={{
        filter: searchFilter,
        setFilter: setSearchFilter,
        total,
      }}
      options={options}
      formatOptionLabel={formatOptionLabel}
      dataTestId='owner-dropdown'
    />
  );
});
